export default __webpack_public_path__ + "static/vmagon-0cb369ca1b89e7ba03e2e4b21eea23ef.jpg";